import React from "react";
import { Box } from "@mui/material";
import NoDataPNG from "../assets/img/norecordfound_new_01.jpg"
const RecordNotFound = () => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
      <div>
        <img src={NoDataPNG} alt="no data found" />
        <br />
      </div>
    </Box>
  );
};
export default RecordNotFound;
